import React from "react";
import Features from "@radarly/components/navigation/navbar/features";
import { useNavbarFeatures } from "@radarly/core/navigation/use-cases";
import { IRouterService } from "@radarly/shared/router";

interface NavbarFeaturesProps {
  router: IRouterService;
  onOpenPanel: (feature: string) => void;
}

export function NavbarFeatures({ onOpenPanel, router }: NavbarFeaturesProps) {
  const { features } = useNavbarFeatures(router);
  return <Features openFeature={onOpenPanel} features={features} pullRight />;
}
